import React, { useState, useCallback } from 'react';
import kk from '../img/KK-zoo.png';
import cm from '../img/CM-zoo.png';
import kn from '../img/KN-zoo.png';
import nm from '../img/NM-zoo.png';
import sk from '../img/SK-zoo.png';
import ub from '../img/UB-zoo.png';

import Navbar from '../navbarv2/navbar';
import Footer from '../navbarv2/footer';

// ─────────────────────────────────────────────────────────────────────────────
// Zoo Data
// ─────────────────────────────────────────────────────────────────────────────

const zooPages = [
  {
    logo: kk,
    sheet: 'https://addpay.net/emember/zoolineoa/imzoopage/kk001.png',
    showTime: 'https://addpay.net/emember/zoolineoa/imzoopage/kk002.png',
    name: 'สวนสัตว์เปิดเขาเขียว',
  },
  {
    logo: ub,
    sheet: 'https://addpay.net/emember/zoolineoa/imzoopage/ubon01.jpg',
    showTime: 'https://addpay.net/emember/zoolineoa/imzoopage/ubon002.png',
    name: 'สวนสัตว์อุบลราชธานี',
  },
  {
    logo: cm,
    sheet: 'https://addpay.net/emember/zoolineoa/imzoopage/cm001.jpg',
    showTime: 'https://addpay.net/emember/zoolineoa/imzoopage/cm002.jpg',
    name: 'สวนสัตว์เชียงใหม่',
  },
  {
    logo: nm,
    sheet: 'https://addpay.net/emember/zoolineoa/imzoopage/korat01.jpg',
    showTime: 'https://addpay.net/emember/zoolineoa/imzoopage/korat02.png',
    name: 'สวนสัตว์นครราชสีมา',
  },
  {
    logo: kn,
    sheet: 'https://addpay.net/emember/zoolineoa/imzoopage/kn001.jpg',
    showTime: 'https://addpay.net/emember/zoolineoa/imzoopage/kn002.jpg',
    name: 'สวนสัตว์ขอนแก่น',
  },
  {
    logo: sk,
    sheet: 'https://addpay.net/emember/zoolineoa/imzoopage/sk002.jpg',
    showTime: 'https://addpay.net/emember/zoolineoa/imzoopage/sk01.png',
    name: 'สวนสัตว์สงขลา',
  },
];

const shortName = (name) =>
  name.replace('สวนสัตว์', '').replace('เปิด', '').trim();

// ─────────────────────────────────────────────────────────────────────────────
// Styles
// ─────────────────────────────────────────────────────────────────────────────

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');

  .zl-page {
    min-height: 100vh;
    background: #f5f7fa;
    font-family: 'Outfit', 'Kanit', sans-serif;
  }

  /* ── Top Bar ── */
  .zl-topbar {
    background: linear-gradient(to bottom, #e8f8ee, #fff);
    padding: 14px 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    border-bottom: 1px solid #e5e7eb;
  }

  .zl-back-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: rgba(46,125,50,0.1);
    border: none;
    cursor: pointer;
    color: #2e7d32;
    font-size: 16px;
    transition: background 0.2s;
    flex-shrink: 0;
  }
  .zl-back-btn:hover { background: rgba(46,125,50,0.18); }

  .zl-topbar-title {
    font-size: 16px;
    font-weight: 700;
    color: #1a1a1a;
    flex: 1;
    text-align: center;
  }

  .zl-topbar-spacer {
    width: 36px;
    flex-shrink: 0;
  }

  /* ── Zoo Chips ── */
  .zl-chips-wrapper {
    background: #fff;
    padding: 12px 16px;
    border-bottom: 1px solid #e5e7eb;
  }

  .zl-chips-label {
    display: flex;
    align-items: center;
    gap: 7px;
    margin-bottom: 10px;
  }

  .zl-chips-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 7px;
    background: rgba(46,125,50,0.1);
    color: #2e7d32;
    font-size: 12px;
  }

  .zl-chips-text {
    font-size: 12px;
    font-weight: 600;
    color: #555;
  }

  .zl-chips-scroll {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding-bottom: 2px;
  }
  .zl-chips-scroll::-webkit-scrollbar { display: none; }

  .zl-chip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    border-radius: 40px;
    border: 1px solid #ddd;
    background: #f5f7fa;
    cursor: pointer;
    transition: all 0.18s ease-out;
    white-space: nowrap;
    flex-shrink: 0;
    font-family: inherit;
    font-size: 12px;
    font-weight: 600;
    color: #444;
  }

  .zl-chip:hover {
    border-color: #aaa;
    background: #eee;
  }

  .zl-chip.active {
    background: #2e7d32;
    border-color: #2e7d32;
    color: #fff;
    box-shadow: 0 2px 8px rgba(46,125,50,0.25);
  }

  .zl-chip-logo {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    object-fit: contain;
  }

  /* ── Tab Bar ── */
  .zl-tabs {
    background: #fff;
    display: flex;
    border-bottom: 1px solid #e5e7eb;
  }

  .zl-tab {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 14px 0;
    font-family: inherit;
    font-size: 13px;
    font-weight: 500;
    color: #999;
    cursor: pointer;
    background: none;
    border: none;
    border-bottom: 3px solid transparent;
    transition: all 0.2s;
  }

  .zl-tab:hover { color: #666; }

  .zl-tab.active {
    color: #2e7d32;
    font-weight: 700;
    border-bottom-color: #2e7d32;
  }

  .zl-tab-icon {
    font-size: 15px;
  }

  /* ── Image Content ── */
  .zl-content {
    padding: 16px;
    max-width: 800px;
    margin: 0 auto;
    animation: zlFadeIn 0.3s ease;
  }

  @keyframes zlFadeIn {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .zl-image-card {
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 5px 20px rgba(0,0,0,0.08);
    cursor: pointer;
    background: #eef2f5;
    min-height: 200px;
  }

  .zl-image-card:hover .zl-image-main {
    transform: scale(1.01);
  }

  .zl-image-main {
    width: 100%;
    display: block;
    transition: transform 0.4s ease, opacity 0.3s ease;
  }

  .zl-image-main.loading {
    opacity: 0;
  }

  /* Loading Spinner */
  .zl-loading {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #eef2f5;
    gap: 12px;
  }

  .zl-spinner {
    width: 40px;
    height: 40px;
    border: 2.5px solid #ddd;
    border-top-color: #2e7d32;
    border-radius: 50%;
    animation: zlSpin 0.8s linear infinite;
  }

  @keyframes zlSpin {
    to { transform: rotate(360deg); }
  }

  .zl-loading-text {
    font-size: 12px;
    color: #999;
  }

  /* Error State */
  .zl-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    background: #eef2f5;
    border-radius: 16px;
    gap: 8px;
  }

  .zl-error-icon {
    font-size: 40px;
    color: #bbb;
  }

  .zl-error-text {
    font-size: 13px;
    color: #bbb;
  }

  /* Fullscreen Badge */
  .zl-fullscreen-badge {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 6px;
    background: rgba(0,0,0,0.4);
    border-radius: 8px;
    color: #fff;
    font-size: 18px;
    line-height: 1;
    pointer-events: none;
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Hint Text */
  .zl-hint {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    margin-top: 12px;
    font-size: 12px;
    color: #bbb;
  }

  .zl-hint-icon {
    font-size: 14px;
  }

  /* ── Fullscreen Lightbox ── */
  .zl-lightbox {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0,0,0,0.92);
    display: flex;
    flex-direction: column;
    animation: zlLightIn 0.25s ease;
  }

  @keyframes zlLightIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  .zl-lightbox-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    flex-shrink: 0;
  }

  .zl-lightbox-title {
    font-size: 14px;
    font-weight: 600;
    color: rgba(255,255,255,0.8);
  }

  .zl-lightbox-close {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: rgba(255,255,255,0.1);
    border: none;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
  }
  .zl-lightbox-close:hover { background: rgba(255,255,255,0.2); }

  .zl-lightbox-body {
    flex: 1;
    overflow: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    cursor: grab;
  }
  .zl-lightbox-body:active { cursor: grabbing; }

  .zl-lightbox-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-radius: 8px;
    transition: transform 0.2s ease;
    user-select: none;
    -webkit-user-drag: none;
  }

  .zl-lightbox-controls {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 12px 16px;
    flex-shrink: 0;
  }

  .zl-zoom-btn {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: rgba(255,255,255,0.1);
    border: 1px solid rgba(255,255,255,0.15);
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
  }
  .zl-zoom-btn:hover { background: rgba(255,255,255,0.2); }

  .zl-zoom-level {
    font-size: 13px;
    color: rgba(255,255,255,0.6);
    min-width: 50px;
    text-align: center;
  }

  /* ── Responsive ── */
  @media (min-width: 768px) {
    .zl-topbar { padding: 14px 32px; }
    .zl-chips-wrapper { padding: 14px 32px; }
    .zl-content { padding: 24px 32px; }
  }

  @media (min-width: 1200px) {
    .zl-content { max-width: 900px; }
  }
`;

// ─────────────────────────────────────────────────────────────────────────────
// ZooImageTab — loads one image with loading/error states
// ─────────────────────────────────────────────────────────────────────────────

function ZooImageTab({ imageUrl, onFullscreen }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleLoad = () => {
    setLoading(false);
    setError(false);
  };

  const handleError = () => {
    setLoading(false);
    setError(true);
  };

  // Reset state when imageUrl changes
  React.useEffect(() => {
    setLoading(true);
    setError(false);
  }, [imageUrl]);

  if (error) {
    return (
      <div className="zl-error">
        <span className="zl-error-icon">🖼</span>
        <span className="zl-error-text">ไม่สามารถโหลดรูปได้</span>
      </div>
    );
  }

  return (
    <>
      <div className="zl-image-card" onClick={() => !loading && onFullscreen(imageUrl)}>
        {loading && (
          <div className="zl-loading">
            <div className="zl-spinner" />
            <span className="zl-loading-text">กำลังโหลด...</span>
          </div>
        )}
        <img
          key={imageUrl}
          src={imageUrl}
          alt="zoo content"
          className={`zl-image-main${loading ? ' loading' : ''}`}
          onLoad={handleLoad}
          onError={handleError}
        />
        {!loading && (
          <div className="zl-fullscreen-badge">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 3 21 3 21 9" />
              <polyline points="9 21 3 21 3 15" />
              <line x1="21" y1="3" x2="14" y2="10" />
              <line x1="3" y1="21" x2="10" y2="14" />
            </svg>
          </div>
        )}
      </div>
      {!loading && (
        <div className="zl-hint">
          <span className="zl-hint-icon">👆</span>
          <span>แตะรูปเพื่อดูแบบเต็มจอ</span>
        </div>
      )}
    </>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// FullscreenLightbox — pinch/zoom image viewer
// ─────────────────────────────────────────────────────────────────────────────

function FullscreenLightbox({ imageUrl, title, onClose }) {
  const [zoom, setZoom] = useState(1);

  const zoomIn = () => setZoom((z) => Math.min(z + 0.5, 4));
  const zoomOut = () => setZoom((z) => Math.max(z - 0.5, 0.5));
  const resetZoom = () => setZoom(1);

  // Close on Escape
  React.useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose]);

  // Prevent body scroll
  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <div className="zl-lightbox">
      <div className="zl-lightbox-header">
        <span className="zl-lightbox-title">{title}</span>
        <button className="zl-lightbox-close" onClick={onClose}>✕</button>
      </div>
      <div className="zl-lightbox-body" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
        <img
          src={imageUrl}
          alt="fullscreen"
          className="zl-lightbox-img"
          style={{ transform: `scale(${zoom})` }}
          onDoubleClick={() => setZoom(z => z === 1 ? 2 : 1)}
          draggable={false}
        />
      </div>
      <div className="zl-lightbox-controls">
        <button className="zl-zoom-btn" onClick={zoomOut} title="ซูมออก">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
        </button>
        <button className="zl-zoom-btn" onClick={resetZoom} title="รีเซ็ต">
          <span className="zl-zoom-level">{Math.round(zoom * 100)}%</span>
        </button>
        <button className="zl-zoom-btn" onClick={zoomIn} title="ซูมเข้า">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
        </button>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// Main Component
// ─────────────────────────────────────────────────────────────────────────────

const ZooList = () => {
  const [selectedZoo, setSelectedZoo] = useState(zooPages[0]);
  const [activeTab, setActiveTab] = useState(0); // 0 = แผนที่สวน, 1 = ตารางการแสดง
  const [lightboxUrl, setLightboxUrl] = useState(null);

  const handleSelectZoo = (zoo) => {
    setSelectedZoo(zoo);
  };

  const openFullscreen = useCallback((url) => {
    setLightboxUrl(url);
  }, []);

  const closeFullscreen = useCallback(() => {
    setLightboxUrl(null);
  }, []);

  const currentImageUrl = activeTab === 0 ? selectedZoo.sheet : selectedZoo.showTime;
  const tabLabel = activeTab === 0 ? 'แผนที่สวน' : 'ตารางการแสดง';

  return (
    <>
      <style>{styles}</style>
      <div className="zl-page">
        <Navbar />

        {/* ── Top Bar ── */}
        <div className="zl-topbar">
          <button className="zl-back-btn" onClick={() => window.history.back()}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <span className="zl-topbar-title">แผนที่ / รอบการแสดง</span>
          <div className="zl-topbar-spacer" />
        </div>

        {/* ── Zoo Chips ── */}
        <div className="zl-chips-wrapper">
          <div className="zl-chips-label">
            <div className="zl-chips-icon">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
              </svg>
            </div>
            <span className="zl-chips-text">เลือกสวนสัตว์</span>
          </div>
          <div className="zl-chips-scroll">
            {zooPages.map((zoo) => (
              <button
                key={zoo.name}
                className={`zl-chip${selectedZoo.name === zoo.name ? ' active' : ''}`}
                onClick={() => handleSelectZoo(zoo)}
              >
                <img src={zoo.logo} alt="" className="zl-chip-logo" />
                <span>{shortName(zoo.name)}</span>
              </button>
            ))}
          </div>
        </div>

        {/* ── Tab Bar ── */}
        <div className="zl-tabs">
          <button
            className={`zl-tab${activeTab === 0 ? ' active' : ''}`}
            onClick={() => setActiveTab(0)}
          >
            <svg className="zl-tab-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="18" height="18" rx="2"/>
              <path d="M3 9h18"/>
              <path d="M9 21V9"/>
            </svg>
            แผนที่สวน
          </button>
          <button
            className={`zl-tab${activeTab === 1 ? ' active' : ''}`}
            onClick={() => setActiveTab(1)}
          >
            <svg className="zl-tab-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            ตารางการแสดง
          </button>
        </div>

        {/* ── Image Content ── */}
        <div className="zl-content" key={`${selectedZoo.name}-${activeTab}`}>
          <ZooImageTab
            imageUrl={currentImageUrl}
            onFullscreen={openFullscreen}
          />
        </div>

        <Footer />
      </div>

      {/* ── Fullscreen Lightbox ── */}
      {lightboxUrl && (
        <FullscreenLightbox
          imageUrl={lightboxUrl}
          title={`${selectedZoo.name} — ${tabLabel}`}
          onClose={closeFullscreen}
        />
      )}
    </>
  );
};

export default ZooList;
